"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es6.regexp.split");
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _queryList = _interopRequireDefault(require("@/components/queryList"));
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    QueryList: _queryList.default
  },
  data: function data() {
    return {
      pageName: 'aopIntegral',
      searchQuery: {
        brand: '',
        year: null,
        srCode: null,
        srName: ''
      },
      apiModule: 'kpiSet',
      disabledKeyList: ['q1TargetQty', 'q2TargetQty', 'q3TargetQty', 'q4TargetQty'],
      disabledKeyList2: ['oneTargetQty', 'twoTargetQty', 'threeTargetQty', 'fourTargetQty', 'fiveTargetQty', 'sixTargetQty', 'sevenTargetQty', 'eightTargetQty', 'nineTargetQty', 'tenTargetQty', 'elevenTargetQty', 'twelveTargetQty']
    };
  },
  computed: {
    domData: function domData() {
      return {
        srCode: {
          label: this.$t('sfe.aopIntegral.srId'),
          valueKey: 'srCode'
        },
        srName: {
          label: this.$t('sfe.aopIntegral.srName'),
          valueKey: 'srName'
        },
        brand: {
          label: this.$t('common.brand'),
          valueKey: 'brand'
        },
        year: {
          label: this.$t('common.year2'),
          valueKey: 'year',
          inputType: 'date',
          type: 'year'
        }
      };
    },
    tableButtons: function tableButtons() {
      return {
        export: {
          fileName: this.$t('sfe.route.aopintegral'),
          apiUrl: '/protected/quarterlyIntegralKpi/export'
        },
        import: {
          apiUrl: '/protected/quarterlyIntegralKpi/import'
        }
      };
    },
    tableDom: function tableDom() {
      var quarter4List = this.createQuarter4List();
      return (0, _objectSpread2.default)({
        rsmCode: {
          label: this.$t('sfe.aopIntegral.rsmId')
        },
        rsmName: {
          label: this.$t('sfe.aopIntegral.rsmName')
        },
        asmCode: {
          label: this.$t('sfe.aopIntegral.asmId')
        },
        asmName: {
          label: this.$t('sfe.aopIntegral.asmName')
        },
        srCode: {
          label: this.$t('sfe.aopIntegral.srId')
        },
        srName: {
          label: this.$t('sfe.aopIntegral.srName')
        },
        brand: {
          label: this.$t('common.brand')
        },
        year: {
          label: this.$t('common.year2')
        },
        oneTargetQty: {
          label: this.$t('sfe.aopIntegral.oneTargetQty')
        },
        twoTargetQty: {
          label: this.$t('sfe.aopIntegral.twoTargetQty')
        },
        threeTargetQty: {
          label: this.$t('sfe.aopIntegral.threeTargetQty')
        },
        fourTargetQty: {
          label: this.$t('sfe.aopIntegral.fourTargetQty')
        },
        fiveTargetQty: {
          label: this.$t('sfe.aopIntegral.fiveTargetQty')
        },
        sixTargetQty: {
          label: this.$t('sfe.aopIntegral.sixTargetQty')
        },
        sevenTargetQty: {
          label: this.$t('sfe.aopIntegral.sevenTargetQty')
        },
        eightTargetQty: {
          label: this.$t('sfe.aopIntegral.eightTargetQty')
        },
        nineTargetQty: {
          label: this.$t('sfe.aopIntegral.nineTargetQty')
        },
        tenTargetQty: {
          label: this.$t('sfe.aopIntegral.tenTargetQty')
        },
        elevenTargetQty: {
          label: this.$t('sfe.aopIntegral.elevenTargetQty')
        },
        twelveTargetQty: {
          label: this.$t('sfe.aopIntegral.twelveTargetQty')
        }
      }, quarter4List);
    },
    listApi: function listApi() {
      return {
        apiUrl: '/protected/quarterlyIntegralKpi/list'
      };
    }
  },
  methods: {
    createQuarter4List: function createQuarter4List() {
      var _this = this;
      var quarter4 = new Array(4).toString().split(',').map(function (t, i) {
        return i + 1;
      });
      var quarter4List = {};
      quarter4.forEach(function (m) {
        quarter4List["q".concat(m, "TargetQty")] = {
          label: _this.$t("sfe.aopIntegral.q".concat(m, "TargetQty")),
          isCommasNumber: true
        };
      });
      return quarter4List;
    },
    downloadExcel: function downloadExcel() {
      var _this2 = this;
      if (this.isLoading) return;
      var param = (0, _objectSpread2.default)({}, this.searchVal);
      this.isLoading = true;
      var apiModule = this.tableButtons['export']['apiModule'] || this.apiModule;
      var promiseFn = this.$api[apiModule]['exportKpiFile'];
      var fileName = this.$t('sfe.aopIntegral.aopFileName');
      promiseFn('/protected/quarterlyIntegralKpi/exportDetail', param, '').then(function (res) {
        _this2.isLoading = false;
        (0, _utils.downloadFileExcel)(fileName, res.data);
      }).catch(function () {
        _this2.isLoading = false;
      });
    }
  }
};